import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { Container, ContainerCircle } from './styles';

const MAX_VISIBLE_PAGES = 5;

const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

// Janela centralizada de até MAX_VISIBLE_PAGES páginas em torno da página atual.
// Função pura: depende apenas de pageCurrent e totalPages.
const buildPageWindow = (pageCurrent, totalPages) => {
  const windowSize = Math.min(MAX_VISIBLE_PAGES, totalPages);
  const lastPossibleInit = Math.max(1, totalPages - windowSize + 1);
  const pageInit = clamp(pageCurrent - Math.floor(windowSize / 2), 1, lastPossibleInit);
  const pageEnd = Math.min(totalPages, pageInit + windowSize - 1);

  const pages = [];
  for (let index = pageInit; index <= pageEnd; index++) {
    pages.push(index);
  }
  return pages;
};

const Pagination = ({ totalItens, itensByPage, show }) => {
  const history = useHistory();
  const location = useLocation();

  // URL é a única fonte de verdade da página atual.
  const totalPages = itensByPage > 0 ? Math.max(1, Math.ceil(totalItens / itensByPage)) : 1;
  const pageFromUrl = parseInt(new URLSearchParams(location.search).get('page'), 10);
  const pageCurrent = clamp(Number.isNaN(pageFromUrl) ? 1 : pageFromUrl, 1, totalPages);

  const pages = buildPageWindow(pageCurrent, totalPages);

  const handlePage = (page) => {
    if (page === pageCurrent || page < 1 || page > totalPages) {
      return;
    }

    const params = new URLSearchParams(location.search);
    params.set('page', page);
    history.push(`${location.pathname}?${params.toString()}`);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const expandLeftIsDisabled = pageCurrent <= 1;
  const expandRightIsDisabled = pageCurrent >= totalPages;

  return (
    <Container show={show}>
      <ContainerCircle aria-disabled={expandLeftIsDisabled} onClick={() => handlePage(pageCurrent - 1)}>
        <FiChevronLeft />
      </ContainerCircle>
      {pages.map((page) => (
        <ContainerCircle aria-selected={page === pageCurrent} key={page} onClick={() => handlePage(page)}>
          <span>{page}</span>
        </ContainerCircle>
      ))}
      <ContainerCircle aria-disabled={expandRightIsDisabled} onClick={() => handlePage(pageCurrent + 1)}>
        <FiChevronRight />
      </ContainerCircle>
    </Container>
  );
};

export default Pagination;
